import type { GetAudienceQuery } from '../../../graphql/query/audiences/GetAudience.generated.tsx';
import { DECIMAL_TO_PERCENT_FACTOR } from '../AudienceForm/constants.ts';
import type { AudienceShareRecipient } from '../AudienceForm/types.ts';
import { createDefaultShare } from './createDefaultShare.ts';

export const mapAudienceShareToForm = (
  audienceId: string,
  shares: NonNullable<GetAudienceQuery['audience_by_pk']>['audience_share']
): AudienceShareRecipient[] => {
  if (shares.length === 0) {
    return [createDefaultShare(audienceId)];
  }

  const audienceShares: AudienceShareRecipient[] = [];
  const shareGroupMap = new Map<string, number>();

  shares.forEach(share => {
    const revenue_method = share?.revenue_method === 'CPM' ? 'CPM' : 'PoM';
    const value = revenue_method === 'CPM' ? (share?.cpm_cap ?? '') : (share?.third_party_revenue ?? '');
    const externalId = audienceId;
    const recipientId = share?.recipient_account_id;

    if (!recipientId) return;

    const groupKey = `${revenue_method}:${value}:${externalId}`;
    const existingIndex = shareGroupMap.get(groupKey);

    if (existingIndex !== undefined) {
      const groupedShares = audienceShares[existingIndex];

      groupedShares.recipient_account_id.push(recipientId);
    } else {
      const base = {
        recipient_account_id: [recipientId],
        audience_external_openaudience_id: externalId,
      };

      if (revenue_method === 'CPM') {
        const newItem: AudienceShareRecipient = {
          ...base,
          revenue_method: 'CPM',
          value,
          isFeeEnabled: Number(value) > 0,
        };
        audienceShares.push(newItem);
      } else {
        const newItem: AudienceShareRecipient = {
          ...base,
          revenue_method: 'PoM',
          value: value ? (Number(value) * DECIMAL_TO_PERCENT_FACTOR).toString() : value,
          isFeeEnabled: Number(value) > 0,
        };
        audienceShares.push(newItem);
      }

      shareGroupMap.set(groupKey, audienceShares.length - 1);
    }
  });

  audienceShares.push(createDefaultShare(audienceId));

  return audienceShares;
};
